import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { Translation } from 'react-i18next';
import { SectionHelper, Text } from '@wix/design-system';
import { ChangePlanModalContext } from '../../../ChangePlanModalContext';
import s from '../ChangePlanModal.scss';

interface ChangePlanModalMessageProps {
  rootStore: RootStore;
}

const ChangePlanModalMessageComp: React.FC<ChangePlanModalMessageProps> = ({
  rootStore,
}) => {
  const { changePlanDetails } = React.useContext(ChangePlanModalContext);
  const { isDowngradePlanOfDeclineChargeService } = rootStore.appStore;
  const explanationMessageKey = isDowngradePlanOfDeclineChargeService
    ? 'Advanced.Plans_change.decline_plan_modal.danger_message'
    : changePlanDetails.verticalFeatureRemoved
      ? 'Advanced.Plans_change.plan_modal.premium_features_disabled_payments'
      : 'Advanced.Plans_change.plan_modal.premium_features_disabled';

  const originPlanName =
    changePlanDetails.currentPlanDetails.localizedProductName;
  const destinationPlanName =
    changePlanDetails.destinationProductDetails.localizedProductName;
  return (
    <Translation>
      {(t) => (
        <div className={s.sectionHelperContainer}>
          <SectionHelper
            appearance='danger'
            fullWidth
          >
            <Text size='small'>
              {t(explanationMessageKey, {
                planName: destinationPlanName,
                originPlanName,
              })}
            </Text>
          </SectionHelper>
        </div>
      )}
    </Translation>
  );
};

export const ChangePlanModalMessage = withInjectedRootStore(
  ChangePlanModalMessageComp,
);
